import { type MouseEvent, useState } from 'react';

import { copyToClipboard } from '@pkg/utils';

export function useCopyLink(value?: string) {
    const [showCopyToast, setShowCopyToast] = useState(false);
    const handleLinkCopy = (e: MouseEvent<HTMLElement>) => {
        e.preventDefault();
        e.stopPropagation();

        const url = window.location.origin + window.location.pathname;
        const copyValue = value || url;

        copyToClipboard(copyValue, () => {
            setShowCopyToast(true);
            const timeout = window.setTimeout(() => {
                setShowCopyToast(false);
            }, 2000);
            return () => clearTimeout(timeout);
        });
    };

    return { handleLinkCopy, showCopyToast };
}
